module.exports = __webpack_public_path__ + "img/ai_gentext_active.18a7359a.svg";